import { useState, useEffect } from "react";
import { Form, Spin, Tabs, Row, Col, Input, Button, Select, DatePicker, Checkbox, type TabsProps, Flex } from "antd";

import dayjs from 'dayjs';

import { PatternFormat } from "react-number-format";

import { UserOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import { apiPrimarias } from "../../../services/api";
import { disabledDate, isStateValid, pushToBase, resetColor } from "../../../utils/utilsFunctions";

import type { IAutorizacaoConvenio, IConvenente, IConvenio, ICtrlDoc, IDocumento, IEfpc, IEnum, IFundamentacaoLegal, IPessoaJuridica, IPlanoBeneficios, ISelectList } from "../../../components/Interfaces";

import { errorMessage, successMessage, mostrarInfo, mostrarInfoDetail } from "../../../messages/messages";
import type { IErroApi } from "../../../services/api";

import { useLocation, useParams } from "react-router";
import CadInfoBotoes from "../../../components/CadInfoBotoes";
import { carregaListaCaracteristica, carregaListaDocumento, carregaListaFundamentacaoLegal, carregaListaTipoConvenio, carregaListaTipoInstituidor } from "../../PessoaJuridica/services";
import { maskNuMatricula, maskNumeroProcesso, numberOnly } from "../../../utils/maskFunctions";
import FormModalDocumento from "../../../components/FormModalDocumento";
import type { CheckboxProps } from "antd/lib";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBalanceScale, faIdCard, faIdCardAlt } from "@fortawesome/free-solid-svg-icons";
import ModalPlano from "../../PlanoBeneficio/components/ModalPlano";
import Convenente from "../Componentes/Convenente";

const Cadastrar = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { tipo } = useParams();

  const [form] = Form.useForm();
  const [convenioRetPosCadastro, setConvenioRetPosCadastro] = useState<IConvenio>();

  const [operacaoAutorizarConvenio, setOperacaoAutorizarConvenio] = useState<IAutorizacaoConvenio>();
  const [efpcRequerente, setEfpcRequerente] = useState<IEfpc>();
  const [pessoaJuridicaPatrocinador, setPessoaJuridicaPatrocinador] = useState<IPessoaJuridica>();
  const [planoObjeto, setPlanoObjeto] = useState<IPlanoBeneficios>();

  const [possuiSolidariedade, setPossuiSolidariedade] = useState(false);
  const [preveInscricaoAutomatica, setPreveInscricaoAutomatica] = useState(false);

  const [listTipoConvenio, setListTipoConvenio] = useState<ISelectList[]>([]);
  const [listTipoInstituidor, setListTipoInstituidor] = useState<ISelectList[]>([]);
  const [tipoConvenio, setTipoConvenio] = useState(0);
  const [nmTipoConvenio, setNmTipoConvenio] = useState("");
  const [codigoModelo, setCodigoModelo] = useState("");


  const [convenentes, setConvenentes] = useState<IConvenente[]>([]);

  const [termoAdesaoDocumento, setTermoAdesaoDocumento] = useState<IDocumento[]>([]);
  const [convenioDocumentoOutros, setConvenioDocumentoOutros] = useState<IDocumento[]>([]);
  const [convenioDocumentoAnalise, setConvenioDocumentoAnalise] = useState<IDocumento[]>([]);

  const [ctrlDocsTermoAdesaoDocumento, setCtrlDocsTermoAdesaoDocumento] = useState<ICtrlDoc[]>([]);
  const [ctrlDocsConvenioDocumentoOutros, setCtrlDocsConvenioDocumentoOutros] = useState<ICtrlDoc[]>([]);
  const [ctrlDocsConvenioDocumentoAnalise, setCtrlDocsConvenioDocumentoAnalise] = useState<ICtrlDoc[]>([]);

  const [manter, _setManter] = useState(1); // 1 : Inserir / 2 : Consultar / 3 : Editar;
  const [erroApi, setErroApi] = useState<IErroApi>()

  const [listDocumentosTermoAdesao, setListDocumentosTermoAdesao] = useState<ISelectList[]>([]);
  const [listDocumentosOutrosConvenio, setListDocumentosOutrosConvenio] = useState<ISelectList[]>([]);
  const [listDocumentosAnalise, setListDocumentosAnalise] = useState<ISelectList[]>([]);

  const [listFundamentacaoLegal, setListFundamentacaoLegal] = useState<ISelectList[]>([]);
  const [listCaracteristicas, setListCaracteristicas] = useState<ISelectList[]>([]);


  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")

  const [mostrarDetalhesPlano, setMostrarDetalhesPlano] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0)

    setLoading(true);
    //console.log(state);
    const carregaDadosIniciais = async () => {
      carregaListaDocumentosTermoAdesaoOpcoes();
      carregaListaDocumentosOutrosConvenioOpcoes();
      carregaListaDocumentosAnaliseOpcoes();

      carregaListaFundamentacaoLegalOpcoes();
      carregaListaCaracteristicasOpcoes();

      carregaListaTiposConveniosOpcoes();
      carregaListaTiposInstituidorOpcoes();
    }
    carregaDadosIniciais();
    setLoading(false);

    if (isStateValid(state)) {
      if (!tipo) {
        validarOperacaoAutorizarConvenio(state.data);
        validarEfpcRequerente(state.dataEfpcRequerente);
        validarPessoaJuridicaPatrocinador(state.dataPessoaJuridicaPatrocinador);
        validarPlanoObjeto(state.dataPlanoObjeto);
      } else {
        errorMessage("Não foi possível identificar a operação de autorização do convênio de adesão.");
        pushToBase(navigate);
      }
    }

  }, []);

  useEffect(() => {
    if (tipoConvenio) {
      let localNmConvenio = listTipoConvenio.find(f => f.value === tipoConvenio)?.label;
      if (localNmConvenio && localNmConvenio !== "")
        setNmTipoConvenio(localNmConvenio);
    }
  }, [tipoConvenio]);

  useEffect(() => {
    if (convenioRetPosCadastro) pushToManter(convenioRetPosCadastro);
  }, [convenioRetPosCadastro]);

  useEffect(() => {
    if (operacaoAutorizarConvenio) {
      form.setFieldsValue({
        operacaoDtPosicao: operacaoAutorizarConvenio.dataPosicao ? dayjs(operacaoAutorizarConvenio.dataPosicao) : undefined,
        operacaoNumero: operacaoAutorizarConvenio.numero,
      });
    }
    if (efpcRequerente) {
      form.setFieldsValue({
        operacaoSiglaEfpc: efpcRequerente.sigla ? efpcRequerente.sigla : "",
      });
    }
    if (pessoaJuridicaPatrocinador) {
      form.setFieldsValue({
        operacaoCnpjPatrocinador: pessoaJuridicaPatrocinador.tipoIdentificador === 1 ? pessoaJuridicaPatrocinador.numero : undefined,
        operacaoNifPatrocinador: pessoaJuridicaPatrocinador.tipoIdentificador === 2 ? pessoaJuridicaPatrocinador.numero : undefined,
      });
    }
    if (planoObjeto) {
      form.setFieldsValue({
        planoNumeroCnpb: planoObjeto.numero,
        planoNome: planoObjeto.nome,
        planoNmCaracteristica: listCaracteristicas.find(f => f.value == planoObjeto.caracteristica)?.label,
        planoNmFundLegal: listFundamentacaoLegal.find(f => f.value === planoObjeto.fundamentacaoLegal)?.label,
      });
    }
  }, [operacaoAutorizarConvenio, efpcRequerente, pessoaJuridicaPatrocinador, planoObjeto]);

  function validarOperacaoAutorizarConvenio(opsConv: IAutorizacaoConvenio) {
    if (!opsConv || opsConv.numero === "") {
      errorMessage("A Operação de Autorização de Convênio de Adesão não foi identificada.");
      pushToBase(navigate);
    } else {
      setOperacaoAutorizarConvenio(opsConv);
    }
  }

  function validarEfpcRequerente(efpcReq: IEfpc) {
    if (!efpcReq) {
      errorMessage("Entidade Requerente não identificada");
      pushToBase(navigate);
    } else {
      setEfpcRequerente(efpcReq);
    }
  }

  function validarPessoaJuridicaPatrocinador(pjPat: IPessoaJuridica) {
    if (!pjPat) {
      errorMessage("Pessoa Juridica do Patrocinador não identificada");
      pushToBase(navigate);
    } else {
      setPessoaJuridicaPatrocinador(pjPat);
    }
  }

  function validarPlanoObjeto(plano: IPlanoBeneficios) {
    if (!plano) {
      errorMessage("Plano de Benefícios Objeto não identificado");
      pushToBase(navigate);
    } else {
      setPlanoObjeto(plano);
    }
  }

  function pushToManter(convenio: IConvenio) {  // ABRE A TELA DE DETALHES DO DIRETOR
    let tpSelecao = {
      manter: 2,
      data: convenio
    }
    navigate("/" + import.meta.env.VITE_APP_BASE + "/conveio-manter", { state: tpSelecao });
  }

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi])

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const validarConvenio = () => {
    if (!pessoaJuridicaPatrocinador || !pessoaJuridicaPatrocinador.numero || pessoaJuridicaPatrocinador.numero === "") {
      errorMessage("Não foi possível identificar a Pessoa Jurídica do Patrocinador para vincular ao Convênio de Adesão.");
      return;
    }

    if (!efpcRequerente || !efpcRequerente.numero || efpcRequerente.numero === "") {
      errorMessage("Não foi possível identificar a Entidade Requerente do Convênio de Adesão.");
      return;
    }

    if (!planoObjeto || !planoObjeto.numero || planoObjeto.numero === "") {
      errorMessage("Não foi possível identificar o Plano de Benefícios objeto do Convênio de Adesão.");
      return;
    }

    form
      .validateFields()
      .then(() => {
        sendForm();
      })
      .catch((_error) => {
        errorMessage("Campo obrigatório não preechido");
      });

  };

  const sendForm = async () => {
    const currentForm = form.getFieldsValue();

    setTipLoading("Salvando dados ...");
    setLoading(true);

    const json: IConvenio =
    {
      numero: "",
      serie: undefined,
      seriePlano: planoObjeto?.serie,
      numeroProcesso: numberOnly(currentForm.convenioNumeroProcesso),
      codigoModelo: codigoModelo,
      tipoConvenio: tipoConvenio,
      possuiSolidariedade: possuiSolidariedade,
      preveInscricaoAutomatica: preveInscricaoAutomatica,
      dataInicioVigencia: currentForm.dataAprovacaoAutorizacao ? dayjs(currentForm.dataAprovacaoAutorizacao).format("YYYY-MM-DD") : "",
      documentos: [
        ...(termoAdesaoDocumento ?? []),
        ...(convenioDocumentoOutros ?? []),
        ...(convenioDocumentoAnalise ?? [])
      ].map((e: IDocumento) => ({ ...e })),
      convenentes: convenentes.map((e: IConvenente) => {
        return {
          ...e
        };
      }),
    }

    try {
      let query = `/efpc/autorizacao/aprovar/${operacaoAutorizarConvenio?.numero}`;

      await apiPrimarias.post(query, json).then((response) => {
        //console.log(response);
        successMessage(
          `Entidade ${response.data.sigla} (${maskNuMatricula(response.data.numero)}) cadastrado com Sucesso`
        );
        setConvenioRetPosCadastro(response.data);
      })
    } catch (error: any) {
      let data: IErroApi = error.response.data;
      let msgErro = data.mensagem ? data.mensagem : error.response.data.message;
      let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
      setEstadoErroApi(error.response.status);
      setMsgErroApi(msgErro + msgDetalheErro);
      if (error.response.status < 500) {
        setErroApi(data);
      } else {
        if (error.response.status === 503)
          errorMessage("Servidor remoto não disponível");
        else
          errorMessage(msgErro);
      }
    } finally {
      setLoading(false);
    }

  };

  const onFinishFailed = () => {
    errorMessage("Campo obrigatório não preechido");
  };

  const resetForm = () => {
    setLoading(true);
    form.getFieldsValue();
    form.setFieldsValue({
      idEfpc: undefined,
      idPessoaJuridica: undefined,
      dtInicioAtuacao: undefined,
      dtFimAtuacao: undefined,
      campoServidorPublico: undefined,
      nuCnpj: undefined,
      razaoSocial: undefined,
      matriculaSiape: undefined,
      nmCargoOrigem: undefined,
    });
    setLoading(false);
    window.scrollTo(0, 0)
  };

  const carregaListaDocumentosTermoAdesaoOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("1126999420597250").then((response) => {
      setCtrlDocsTermoAdesaoDocumento(response.data);
      response.data.forEach((p: ICtrlDoc) => {
        listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
      });
      setListDocumentosTermoAdesao(listaLocal);
    });
  }

  const carregaListaDocumentosOutrosConvenioOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("2252899327439874").then((response) => {
      setCtrlDocsConvenioDocumentoOutros(response.data);
      response.data.forEach((p: ICtrlDoc) => {
        listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
      });
    });
    setListDocumentosOutrosConvenio(listaLocal);
  }

  const carregaListaDocumentosAnaliseOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("4504699141125121").then((response) => {
      setCtrlDocsConvenioDocumentoAnalise(response.data);
      response.data.forEach((p: ICtrlDoc) => {
        listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
      });
    });
    setListDocumentosAnalise(listaLocal);
  }

  const carregaListaFundamentacaoLegalOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaFundamentacaoLegal().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListFundamentacaoLegal(listaLocal);
  }

  const carregaListaCaracteristicasOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaCaracteristica().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListCaracteristicas(listaLocal);
  }

  const carregaListaTiposConveniosOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaTipoConvenio().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
      setListTipoConvenio(listaLocal);
    });
  }

  const carregaListaTiposInstituidorOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaTipoInstituidor().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
      setListTipoInstituidor(listaLocal);
    });
  }

  const onChangePossuiSolidariedade: CheckboxProps['onChange'] = (e) => {
    setPossuiSolidariedade(e.target.checked);
  };

  const onChangePreveInscricaoAutomatica: CheckboxProps['onChange'] = (e) => {
    setPreveInscricaoAutomatica(e.target.checked);
  };

  const handlerTipoConvenio = (tpReg: any) => {
    setTipoConvenio(tpReg.value);
    setNmTipoConvenio(tpReg.label);
    form.setFieldsValue({
      "nmTipoConvenio": tpReg.label.toUpperCase(),
    })

    form.resetFields([
      "codigoModelo",
    ]);
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Convênio/Termo de Adesão',
      icon: <FontAwesomeIcon icon={faBalanceScale} />,
      children:
        <>
          <Form layout='vertical' style={{ padding: 24 }} scrollToFirstError form={form} >
            <Row>
              <Col xs={24} sm={8}>
                <Form.Item label="Tipo de Convênio"
                  labelAlign="left"
                  labelCol={{ span: 20 }}
                  name="nmTipoConvenio"
                  colon={false}
                  rules={[
                    {
                      required: manter !== 2 ? true : false,
                      message: "Selecione o Tipo de Convênio",
                    },
                  ]}
                >
                  <Select
                    disabled={manter === 2 ? true : false}
                    placeholder="Tipo de Convênio"
                    showSearch
                    filterOption
                    optionFilterProp='children'
                    options={listTipoConvenio}
                    onChange={(_, index) => {
                      handlerTipoConvenio(index);
                    }}
                  />

                </Form.Item>
              </Col>

              <Col xs={24} sm={6}>
                <Form.Item label="Código do Modelo"
                  name="codigoModelo"
                  colon={false}
                  rules={[
                    {
                      required: manter !== 2 ? nmTipoConvenio.includes("MODELO") ? true : false : false,
                      message: "Preencha o Código do Modelo",
                    },
                  ]}
                >
                  <Input
                    disabled={manter === 2 ? true : !nmTipoConvenio.includes("MODELO") ? true : false}
                    onBlur={(e) => {
                      setCodigoModelo(e.target.value);
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <FormModalDocumento
            ctrlDoc={ctrlDocsTermoAdesaoDocumento}
            objetoDocumento={termoAdesaoDocumento}
            setObjetoDocumento={setTermoAdesaoDocumento}
            listaDocumentos={listDocumentosTermoAdesao}
            manter={manter}
          />
        </>
    },
    {
      key: '2',
      label: 'Convenentes',
      icon: <FontAwesomeIcon icon={faIdCard} />,
      children:
        <Convenente
          form={form}
          convenentes={convenentes}
          setConvenentes={setConvenentes}
          caracteristica={planoObjeto?.caracteristica || 0}
          listTipoInstituidor={listTipoInstituidor}
          manter={manter}
        />
    },
    {
      key: '5',
      label: 'Outros Documentos do Convênio',
      icon: <FontAwesomeIcon icon={faIdCard} />,
      children:
        <FormModalDocumento
          ctrlDoc={ctrlDocsConvenioDocumentoOutros}
          objetoDocumento={convenioDocumentoOutros}
          setObjetoDocumento={setConvenioDocumentoOutros}
          listaDocumentos={listDocumentosOutrosConvenio}
          manter={manter}
        />
    },
    {
      key: '6',
      label: 'Documentação de Análise/Autorização',
      icon: <FontAwesomeIcon icon={faIdCardAlt} />,
      children:
        <FormModalDocumento
          ctrlDoc={ctrlDocsConvenioDocumentoAnalise}
          objetoDocumento={convenioDocumentoAnalise}
          setObjetoDocumento={setConvenioDocumentoAnalise}
          listaDocumentos={listDocumentosAnalise}
          manter={manter}
        />
    },
  ];

  return (
    <>
      <Spin spinning={loading} tip={tipLoading}>

        <Form layout='vertical' style={{ padding: 24 }} scrollToFirstError form={form} >

          <div className="main-content pl-sm-3 mt-4">
            <h1>Cadastrar Convênio/Termo de Adesão</h1>
          </div>

          <div className="main-content pl-sm-3 mt-4">
            <h2>Informações da Operação de Autorização do Convênio</h2>
          </div>

          <Row>
            <Col xs={24} xl={2}>
              <Form.Item label="Número"
                name="operacaoNumero">
                <Input disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} xl={5}>
              <Form.Item
                label="Sigla da Entidade"
                name="operacaoSiglaEfpc">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format="#####-#"
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={5} hidden={pessoaJuridicaPatrocinador?.tipoIdentificador !== 1}>
              <Form.Item
                label="CNPJ do Patrocinador"
                name="operacaoCnpjPatrocinador">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format="##.###.###/####-##"
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={5} hidden={pessoaJuridicaPatrocinador?.tipoIdentificador !== 2}>
              <Form.Item
                label="NIF do Patrocinador"
                name="operacaoNifPatrocinador">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format="##############"
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={5}>
              <Form.Item
                label="Data da Posicao"
                name="operacaoDtPosicao">
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabled
                />
              </Form.Item>
            </Col>
          </Row>

          <div className="main-content pl-sm-3 mt-4">
            <h2>Informações Básicas do Plano de Benefícios</h2>
          </div>

          <Row>
            <Col xs={24} xl={5} >
              <Form.Item
                label="CNPB"
                name="planoNumeroCnpb">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format="####.####-##"
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={10}>
              <Form.Item label="Nome do Plano de Benefícios"
                name="planoNome">
                <Input disabled={true} />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={12} xl={8}>
              <Form.Item
                label="Característica"
                name="planoNmCaracteristica"
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={8}>
              <Form.Item
                label="Fundamentação Legal"
                name="planoNmFundLegal"
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} xl={4} >
              <Form.Item style={{ alignItems: 'center' }}
                label={"Detalhar Cadastro do Plano de Benefícios"}
              >
                <Button
                  shape='round'
                  onClick={() => {
                    setMostrarDetalhesPlano(!mostrarDetalhesPlano);
                  }}
                  type='primary'
                  icon={<UserOutlined />}
                />
              </Form.Item>
            </Col>
          </Row>

          <ModalPlano
            dadosPlano={planoObjeto}
            modalPlanoSucessoAberto={mostrarDetalhesPlano}
            setModalPlanoSucessoAberto={setMostrarDetalhesPlano}
          />

          <div className="main-content pl-sm-3 mt-4">
            <h2>Convênio de Adesão</h2>
          </div>

          <Row>

            <Col xs={24} md={12} xl={5}>
              <Form.Item
                label='Número do Processo'
                name='convenioNumeroProcesso'
                rules={[
                  {
                    required: true,
                    message: "Número do processo não preenchido",
                  },
                ]}
              >
                <Input
                  maxLength={20}
                  onChange={(e) =>
                    form.setFieldsValue({
                      convenioNumeroProcesso: maskNumeroProcesso(e.target.value),
                    })
                  }
                />

              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={5}>
              <Form.Item
                label="Data da Autorização"
                name="dataAprovacaoAutorizacao"
                rules={[
                  {
                    required: true,
                    message: "Data da Autorização obrigatório não preenchido",
                  },
                ]}
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabledDate={disabledDate}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={7} >
              <Flex align="center" style={{ height: '100px' }}>
                <Checkbox onChange={onChangePossuiSolidariedade}>Possui Solidariedade</Checkbox>
              </Flex>
            </Col>

            <Col xs={24} md={12} xl={7}>
              <Flex align="center" style={{ height: '100px' }}>
                <Checkbox onChange={onChangePreveInscricaoAutomatica}>Prevê Inscrição Automática</Checkbox>
              </Flex>
            </Col>
          </Row>

        </Form>

        <Tabs
          defaultActiveKey="1"
          items={items}
        // onChange={onChange} 
        />

        <Form layout='vertical' style={{ padding: 24 }} onFinish={validarConvenio} onFinishFailed={onFinishFailed} scrollToFirstError form={form} >

          <CadInfoBotoes
            resetForm={resetForm}
            detalhar={false}
            form={form}
            resetColor={resetColor}
            manter={1}
            msgConfirmacao={`Convênio de Adesão`}
            rotaConsultar={"/" + import.meta.env.VITE_APP_BASE}
          />

        </Form >
      </Spin >

    </>
  );
};

export default Cadastrar;